import clsx from 'clsx';
import { formatCurrency, formatDateTime } from '../../lib/format';
import type { TransactieRecord } from '../../lib/invoices';

const METHOD_COLORS: Record<string, string> = {
  Mollie: 'bg-blue-100 text-blue-700',
  Pin: 'bg-indigo-100 text-indigo-700',
  Contant: 'bg-amber-100 text-amber-700',
  Bankrekening: 'bg-slate-100 text-slate-600',
  iDEAL: 'bg-purple-100 text-purple-700',
};

function displayReceivedBy(t: TransactieRecord): string {
  if (t.receivedByEmployeeName) return t.receivedByEmployeeName;
  if (t.receivedByUserName) return t.receivedByUserName;
  return '';
}

interface TransactieListProps {
  transacties: TransactieRecord[];
  onDelete?: (id: string) => void;
  deletingId?: string | null;
}

export function TransactieList({ transacties, onDelete, deletingId }: TransactieListProps) {
  if (transacties.length === 0) {
    return (
      <p className="px-4 py-6 text-sm text-slate-400 text-center">
        Nog geen transacties geregistreerd
      </p>
    );
  }

  return (
    <ul className="divide-y divide-slate-100">
      {transacties.map((t) => {
        const color = METHOD_COLORS[t.method] || 'bg-slate-100 text-slate-600';
        const canDelete = !!onDelete && t.method !== 'Mollie';
        const receivedBy = displayReceivedBy(t);
        return (
          <li key={t.id} className="px-4 py-3 flex items-center gap-3">
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 mb-0.5 flex-wrap">
                <span className="text-sm font-medium text-slate-900">
                  {formatCurrency(t.amount)}
                </span>
                <span className={clsx('text-[10px] px-1.5 py-0.5 rounded font-medium', color)}>
                  {t.method || '—'}
                </span>
                <span className="text-xs text-slate-500">{formatDateTime(t.receivedAt)}</span>
              </div>
              <div className="flex items-center gap-3 text-xs text-slate-500">
                {receivedBy && <span>door {receivedBy}</span>}
                {t.notes && (
                  <span className="truncate max-w-[320px]" title={t.notes}>
                    {t.notes}
                  </span>
                )}
              </div>
            </div>
            {canDelete && (
              <button
                type="button"
                onClick={() => onDelete!(t.id)}
                disabled={deletingId === t.id}
                className="text-xs text-red-600 hover:text-red-700 disabled:opacity-50 flex-shrink-0"
              >
                {deletingId === t.id ? 'Bezig…' : 'Verwijder'}
              </button>
            )}
          </li>
        );
      })}
    </ul>
  );
}
